import {
  HEADER_FOOTER_HEIGHT,
  MIN_MODAL_HEIGHT,
  MIN_MODAL_WIDTH,
} from './constants';
import React, { useEffect, useState } from 'react';

import AccountsService from '@omni/kit/services/AccountsService';
import AuthProviderList from '../AuthProviderList';
import AuthService from '@omni/kit/services/AuthService';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import { IProps } from './types';
import KitModal from '@omni/kit/components/KitModalV2';
import { KitTouchableIcon } from '@omni/kit/components';
import Show from '@omni/kit/components/Show';
import Spacing from '@omni/kit/theming/Spacing';
import { View } from 'react-native';
import { colorForScheme } from '@omni/kit/theming/Theming';

const debug = require('debug')('tca:auth:AuthModal');

export default ({
  anchorBottom = false,
  appKey = '',
  customHeader,
  isVisible = false,
  onClose,
  returnUrl = '',
  source = '',
  targetAuthProviderId,
}: IProps): JSX.Element => {
  const [orgKey, setOrgKey] = useState<string | undefined>();
  const [hasBackdrop, setHasBackdrop] = useState(true);

  useEffect(() => {
    return AuthService.addListener('AuthorizationChanged', ({ token }) => {
      if (token) {
        setHasBackdrop(false); // prevent black flicker on dismiss
        onClose?.();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getOrgKey = async () => {
      try {
        const app = await AccountsService.getAppWithBranding(appKey ?? '');

        setOrgKey(app.org_key);
      } catch (e) {
        debug(e);
      }
    };
    appKey && getOrgKey();
  }, [appKey]);

  return (
    <KitModal
      isVisible={isVisible}
      anchorBottom={anchorBottom}
      coverScreen={true}
      hasBackdrop={hasBackdrop}
      onClose={onClose}
    >
      <View
        style={[
          {
            padding: Spacing.m,
            paddingVertical: 30,
            width: '100%',
            minHeight: MIN_MODAL_HEIGHT,
          },
          !anchorBottom && {
            borderRadius: BorderRadius.l,
            minWidth: MIN_MODAL_WIDTH,
            paddingVertical: 0,
          },
        ]}
      >
        <Show show={!anchorBottom}>
          <View>
            <KitTouchableIcon
              color={colorForScheme?.({
                light: Colors.N900,
                dark: Colors.N0,
              })}
              name='remove'
              onPress={onClose}
              style={{
                alignSelf: 'flex-end',
              }}
              buttonSize={HEADER_FOOTER_HEIGHT}
            />
          </View>
        </Show>
        <AuthProviderList
          appKey={appKey}
          customHeader={customHeader}
          orgKey={orgKey}
          customReturnUrl={returnUrl}
          targetAuthProviderId={targetAuthProviderId}
          openInNewTab
        />
        <Show show={!anchorBottom}>
          <View style={{ height: HEADER_FOOTER_HEIGHT }} />
        </Show>
      </View>
    </KitModal>
  );
};
